'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

export default function DirectoryTracker({ province, placeId, category }) {
  useEffect(() => {
    trackEvent(EVENTS.DIRECTORY_PAGE_VIEWED, {
      page_type: placeId ? 'business_detail' : province ? 'province' : 'index',
      province: province || null,
      place_id: placeId || null,
      category: category || null
    });
  }, [category, placeId, province]);

  return null;
}
